
import React, { Component } from 'react';
import Header from "../images/NADRC-Upload-Banner.jpg"
import Moment from 'moment';
import Layout from '../components/layout'
import Editform from '../components/editOneRecord'
const qs = require('querystring'); 

class SubmitRegistration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.props,
            id: qs.parse(this.props.location.search).id,
            currentDate: new Date(),
            
            titleName: "",
            domain: "",
            description: "",
           // created: Moment(new Date()).format("yyyy-MM-DDTHH:mm:ss"),
           
            
            
           
        }
    
       
        
        this.onSubmit = this.onSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
        //this.onChangeImageHandler = this.onChangeImageHandler.bind(this)
        this.onChangeImageHandler1 = this.onChangeImageHandler1.bind(this)
        this.onChangeImageHandler2 = this.onChangeImageHandler2.bind(this)
        this.onChangeImageHandler3 = this.onChangeImageHandler3.bind(this)
        this.onChangeImageHandler4 = this.onChangeImageHandler4.bind(this)
        this.onChangeImageHandler5 = this.onChangeImageHandler5.bind(this)
        
    }



    onChange = e => this.setState({ [e.target.name]: e.target.value });
    onChangeImageHandler1 = e => this.setState({ file1: e.target.files[0] });
    onChangeImageHandler2 = e => this.setState({ file2: e.target.files[0] });
    onChangeImageHandler3 = e => this.setState({ file3: e.target.files[0] });
    onChangeImageHandler4 = e => this.setState({ file4: e.target.files[0] });
    onChangeImageHandler5 = e => this.setState({ file5: e.target.files[0] });

    //onChangeImageHandler4 = e => this.setState({ fileName: e.target.files[0].name, file1: e.target.files[0], file2: e.target.files[0], file3: e.target.files[0], file4: e.target.files[0] });


    onSubmit = (e) => {
        e.preventDefault();
        e.preventDefault();
        e.stopPropagation();

        const formData = new FormData();
        formData.append('nid', this.state.nid);
        formData.append('title', this.state.title);
        formData.append('category', this.state.category);
        formData.append('body', this.state.body);
        formData.append('created', this.state.created);
        formData.append('ndrcKeywords', this.state.ndrcKeywords);
        formData.append('file1', this.state.file1);
        formData.append('file2', this.state.file2);
        formData.append('file3', this.state.file3);
        formData.append('file4', this.state.file4);
        formData.append('file5', this.state.file5);

        fetch(process.env.REACT_APP_LOGIC_APP_URL, {
            mode: 'no-cors',
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data , boundary=?"

            },
            body: formData
        })
            .then(function (res) {
                if (res.ok) {
                    console.log(formData)
                    alert("Perfect! ");
                } else if (res.status == 401) {
                    alert("Oops! ");
                }
            }, function (e) {
                alert(formData);
            });
        this.props.history.push('/Thankyou');

    };


    




    render() {

        

        return (

            <div>
                <Layout>

                    
                <div class="row card-header pt-2 text-sm" style={{ paddingBottom: 20 + "px" }} ><span style={{ paddingLeft: 10 + "px" }}><a href="/">Home</a>/<a href="/view-resources">Resources</a>/Edit</span></div>

                    <div class="mx-auto w-full md:w-3/4 row body_content">

                    <Editform id={this.state.id} />









                    </div >
                </Layout>
            </div>

        );
    }
}



export default SubmitRegistration;

